
export const STEPS = {
    plan: 'plan',
    card: 'card',
    confirm: 'confirm',
};

